import ApplicationErrorBoundary from 'tradera/components/application-error-boundary/application-error-boundary';
import { ProfileMenuContent } from './profile-menu-content';
import { SignInMenuContent } from './sign-in-menu-content';
import { useAppDispatch, useAppSelector } from 'tradera/state/hooks';
import { SideMenu } from 'tradera/components/side-menu/side-menu';
import { closeProfileMenu } from 'tradera/state/ui/reducer';
import useIsMobile from 'tradera/hooks/use-is-mobile';
import styles from './profile-menu.module.scss';
import { ScrollableModal } from 'tradera/components/scrollable-modal/scrollable-modal';
import TraderaSymbol from '@tradera/blueprint/theme/logos/tradera_symbol.svg?jsx';
import { useGrowthBook } from '@growthbook/growthbook-react';
import { selectPreviousLoginMethod } from 'tradera/state/member/selectors';

type ProfileMenuProps = {
    show: boolean;
};

export const ProfileMenu = ({ show }: ProfileMenuProps) => {
    const { isLoggedIn } = useAppSelector((state) => state.member);
    const dispatch = useAppDispatch();
    const isMobile = useIsMobile();

    // only activate experiment is user has a previous login method
    const previousLoginMethod = useAppSelector(selectPreviousLoginMethod);
    const growthBook = useGrowthBook();
    const experimentValue = previousLoginMethod
        ? growthBook?.getFeatureValue('tgl-620-show-latest-login-option', 0)
        : 0;
    const experimentIsOn = experimentValue === 2;

    const onClose = () => {
        dispatch(closeProfileMenu());
    };

    return (
        <ApplicationErrorBoundary>
            {!isLoggedIn && experimentIsOn ? (
                <ScrollableModal
                    dismissOnOverlayClick
                    mobileBottomSheet
                    show={show}
                    onClose={onClose}
                    maxWidth="450px">
                    <div className={styles.modalLogo}>
                        <TraderaSymbol id="tradera-symbol" />
                    </div>
                    <SignInMenuContent
                        iframeClassName={styles.minHeight}
                        closeMenu={onClose}
                        showCloseButton={false}
                    />
                </ScrollableModal>
            ) : (
                <SideMenu
                    show={show}
                    onDismiss={onClose}
                    width={isMobile ? '22rem' : '28rem'}>
                    <div className={styles.profileMenu}>
                        {isLoggedIn ? (
                            <ProfileMenuContent onClose={onClose} />
                        ) : (
                            <SignInMenuContent closeMenu={onClose} />
                        )}
                    </div>
                </SideMenu>
            )}
        </ApplicationErrorBoundary>
    );
};
